import { render, staticRenderFns } from "./ReglamentoInstalaciones.vue?vue&type=template&id=0f48b66e&scoped=true"
import script from "./ReglamentoInstalaciones.vue?vue&type=script&lang=js"
export * from "./ReglamentoInstalaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48b66e",
  null
  
)

export default component.exports